export const LOCALE_COOKIE = "softmap_locale";
export const SUPPORTED_LOCALES = ["zh-CN", "zh-TW", "en"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

/** 只接受白名单语言；非法 Cookie 必须在进入 React 树前被丢弃，避免污染 SSR 或日志。 */
export function parseLocale(value: string | undefined | null): Locale | null {
  const normalized = value?.trim();
  return normalized && (SUPPORTED_LOCALES as readonly string[]).includes(normalized) ? normalized as Locale : null;
}

function languageToLocale(value: string): Locale | null {
  const normalized = value.trim().toLowerCase().replace(/_/g, "-");
  if (normalized === "en" || normalized.startsWith("en-")) return "en";
  if (normalized === "zh-tw" || normalized === "zh-hk" || normalized === "zh-mo" || normalized.includes("hant")) return "zh-TW";
  if (normalized === "zh" || normalized.startsWith("zh-") || normalized.includes("hans")) return "zh-CN";
  return null;
}

/** 按 q 权重选择第一个支持的语言；不把浏览器原始头部写入状态。 */
export function resolveLocale(cookieValue?: string, acceptLanguage?: string): Locale {
  return parseLocale(cookieValue) ??
    (acceptLanguage ?? "").split(",").map((part, index) => {
      const [tag, ...parameters] = part.trim().split(";");
      const q = parameters.find((parameter) => parameter.trim().startsWith("q="));
      const weight = q ? Number(q.trim().slice(2)) : 1;
      return {tag, weight: Number.isFinite(weight) ? weight : 0, index};
    }).filter((item) => item.tag && item.weight > 0).sort((a, b) => b.weight - a.weight || a.index - b.index).map((item) => languageToLocale(item.tag)).find((locale): locale is Locale => locale !== null) ?? "zh-CN";
}

export function localeHtmlLang(locale: Locale): "zh-Hans" | "zh-Hant" | "en" {
  return locale === "en" ? "en" : locale === "zh-TW" ? "zh-Hant" : "zh-Hans";
}

export function localeDisplayName(locale: Locale): string {
  return locale === "zh-CN" ? "简" : locale === "zh-TW" ? "繁" : "EN";
}
